'use client'

import dynamic from 'next/dynamic'
import React from 'react'

import type { ContactUsOrdersReturnsDSProps } from '@src/components/blocks/contact-us-orders-returns-ds'
import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import OrdersAndReturnsSectionLegacy from './orders-return-legacy'

// dynamic import keeps Panda styles out of the legacy bundle; ssr stays on for identical server HTML
const OrdersReturnsDS = dynamic(
  () =>
    import(
      /* webpackChunkName: "contact-us-orders-returns-ds" */ '@src/components/blocks/contact-us-orders-returns-ds/contact-us-orders-returns-ds'
    ),
)

const OrdersAndReturnsSection = (props: ContactUsOrdersReturnsDSProps) => {
  if (shouldUseDesignSystem()) {
    return <OrdersReturnsDS {...props} />
  }
  return <OrdersAndReturnsSectionLegacy {...props} />
}

export default OrdersAndReturnsSection
